import { useEffect, useState } from 'react';
import { useAudioRecorder } from 'react-audio-voice-recorder';
import _ from 'lodash';

import { AudioRecorderDefaultConfig } from '../../components/audioRecorder/AudioRecorder';
import { Button } from '../../components/Button';
import { fetchMeanValue, isHeadsetMicrophone } from '../../service/MicService';
import { Text } from '../../components/Text';
import { changeSilenceValue } from '../../redux/appConfigSlice';
import { AppDispatch } from '../../redux/store';
import { useDispatch } from 'react-redux';
import { getButtonSize } from '../../service/utils';
import { ScreenButtonSize } from '../../interface/interface';


interface SilenceCheckScreenProps {
    selectedMic?: string;
    setIsTimerFinished: (val: boolean) => void; 
    selectedMicLabel?: string;
    fontSize: ScreenButtonSize;
    rulesIsSet?: boolean;
}

const SilenceCheckScreen = (props: SilenceCheckScreenProps) => {
    const { fontSize, rulesIsSet } = props;
    const [buttonLabel, setButtonLabel] = useState(5);
    const [isSilenceFinished, setIsSilenceFinished] = useState(false);
    const dispatch = useDispatch<AppDispatch>();

    let audioRecorder = useAudioRecorder({
        ...AudioRecorderDefaultConfig,
        deviceId: props.selectedMic ?? 'default',
    });

    useEffect(() => {
        if (audioRecorder.recordingBlob && !audioRecorder.isRecording) {
            fetchMeanValue(audioRecorder.recordingBlob).then((mValue: any) => {
                dispatch(changeSilenceValue(mValue));
                finishPage();
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [audioRecorder.isRecording, audioRecorder.recordingBlob, props]);

    useEffect(() => {
        if (isSilenceFinished) {
            audioRecorder?.stopRecording();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSilenceFinished, props]);

    const finishPage = () => {
        setTimeout(() => props.setIsTimerFinished(true), 1);
    };

    /* Start the timer */
    const startCounter = async () => {
        audioRecorder.startRecording(); // Start recording before timer starts
        let interval = setInterval(() => {
            setButtonLabel((currLabel) => {
                if (currLabel !== 1) {
                    return currLabel - 1;
                } else {
                    setIsSilenceFinished(true);
                    clearInterval(interval);
                }
                return 0;
            });
        }, 1000);
    };

    const getDisabledButtonState = () => {
        if (props.selectedMic) {
           if (rulesIsSet) {
                return false;
           } else {
                return true;
           }
        }
        return true;
    }

    return (
        <>
            <p>
                <Text text="We need to check the sound in the room." />
            </p>
            <p>
                <Text text="Click <b>Start</b>, then stay quiet for 5 seconds." />
            </p>
            <p>
                <Text text="Please don't say anything during this time." />
            </p>

            <Button
                disabled={getDisabledButtonState()}
                size={getButtonSize(fontSize)}
                onClick={buttonLabel === 5 ? startCounter : _.noop}
                locked={buttonLabel !== 5}
                id='start'
                loading={!rulesIsSet}
            >
                {buttonLabel === 5 ? 'Start' : buttonLabel}
            </Button>
        </>
    );
};

export default SilenceCheckScreen;
